import { render } from "./UserInfoSkeleton.vue?vue&type=template&id=f8cf1e12&ts=true"
import script from "./UserInfoSkeleton.vue?vue&type=script&lang=ts"
export * from "./UserInfoSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__